@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(2_132_466_893)
public val Res.string.staff_status_expired: StringResource by lazy {
      StringResource("string:staff_status_expired", "staff_status_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 342887, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 488795, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314714, 40),
      ))
    }

@delegate:ResourceContentHash(607_425_712)
public val Res.string.staff_status_expiring: StringResource by lazy {
      StringResource("string:staff_status_expiring", "staff_status_expiring", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 342928, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 488856, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314755, 45),
      ))
    }

@delegate:ResourceContentHash(859_597_450)
public val Res.string.staff_status_missing: StringResource by lazy {
      StringResource("string:staff_status_missing", "staff_status_missing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 342978, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 488922, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314801, 44),
      ))
    }

@delegate:ResourceContentHash(1_689_113_815)
public val Res.string.staff_status_valid: StringResource by lazy {
      StringResource("string:staff_status_valid", "staff_status_valid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 343023, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 488979, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314846, 34),
      ))
    }

@delegate:ResourceContentHash(-1_885_295_002)
public val Res.string.staffing_card_all_right: StringResource by lazy {
      StringResource("string:staffing_card_all_right", "staffing_card_all_right", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 343058, 123),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 489026, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314881, 115),
      ))
    }

@delegate:ResourceContentHash(1_178_556_279)
public val Res.string.staffing_card_open: StringResource by lazy {
      StringResource("string:staffing_card_open", "staffing_card_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 343182, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 489230, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314997, 46),
      ))
    }

@delegate:ResourceContentHash(2_065_532_179)
public val Res.string.staffing_card_summary: StringResource by lazy {
      StringResource("string:staffing_card_summary", "staffing_card_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 343292, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 489380, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 315111, 53),
      ))
    }

@delegate:ResourceContentHash(77_557_413)
public val Res.string.staffing_card_summary_both: StringResource by lazy {
      StringResource("string:staffing_card_summary_both", "staffing_card_summary_both", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 343229, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 489297, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 315044, 66),
      ))
    }

@delegate:ResourceContentHash(-1_626_330_163)
public val Res.string.staffing_card_title: StringResource by lazy {
      StringResource("string:staffing_card_title", "staffing_card_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 343342, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 489450, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 315165, 47),
      ))
    }

@delegate:ResourceContentHash(503_519_287)
public val Res.string.staffing_hint_add_hours: StringResource by lazy {
      StringResource("string:staffing_hint_add_hours", "staffing_hint_add_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 343394, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 489530, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 315213, 87),
      ))
    }

@delegate:ResourceContentHash(112_727_740)
public val Res.string.staffing_hint_cut_hours: StringResource by lazy {
      StringResource("string:staffing_hint_cut_hours", "staffing_hint_cut_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 343474, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 489658, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 315301, 95),
      ))
    }

@delegate:ResourceContentHash(660_242_579)
public val Res.string.staffing_hint_from_forecast: StringResource by lazy {
      StringResource("string:staffing_hint_from_forecast", "staffing_hint_from_forecast", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 343562, 143),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 489806, 219),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 315397, 135),
      ))
    }

@delegate:ResourceContentHash(-1_610_929_759)
public val Res.string.staffing_hint_from_recent: StringResource by lazy {
      StringResource("string:staffing_hint_from_recent", "staffing_hint_from_recent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 343706, 189),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 490026, 281),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 315533, 153),
      ))
    }

@delegate:ResourceContentHash(-1_843_992_391)
public val Res.string.staffing_hint_from_target: StringResource by lazy {
      StringResource("string:staffing_hint_from_target", "staffing_hint_from_target", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 343896, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 490308, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 315687, 97),
      ))
    }

@delegate:ResourceContentHash(-1_408_033_659)
public val Res.string.staffing_hint_income: StringResource by lazy {
      StringResource("string:staffing_hint_income", "staffing_hint_income", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 344290, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 490858, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 316041, 96),
      ))
    }

@delegate:ResourceContentHash(2_069_985_271)
public val Res.string.staffing_hint_income_fixed: StringResource by lazy {
      StringResource("string:staffing_hint_income_fixed", "staffing_hint_income_fixed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 344006, 146),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 490458, 206),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 315785, 134),
      ))
    }

@delegate:ResourceContentHash(2_027_813_325)
public val Res.string.staffing_hint_income_sales_fixed: StringResource by lazy {
      StringResource("string:staffing_hint_income_sales_fixed", "staffing_hint_income_sales_fixed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 344153, 136),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 490665, 192),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 315920, 120),
      ))
    }

@delegate:ResourceContentHash(-580_955_265)
public val Res.string.staffing_hint_just_right: StringResource by lazy {
      StringResource("string:staffing_hint_just_right", "staffing_hint_just_right", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 344535, 132),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 491215, 220),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 316274, 128),
      ))
    }

@delegate:ResourceContentHash(-1_472_477_100)
public val Res.string.staffing_hint_just_right_income: StringResource by lazy {
      StringResource("string:staffing_hint_just_right_income", "staffing_hint_just_right_income", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 344395, 139),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 490991, 223),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 316138, 135),
      ))
    }

@delegate:ResourceContentHash(-651_330_846)
public val Res.string.staffing_hint_open_estimated: StringResource by lazy {
      StringResource("string:staffing_hint_open_estimated", "staffing_hint_open_estimated", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 344668, 108),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 491436, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 316403, 112),
      ))
    }

@delegate:ResourceContentHash(371_976_176)
public val Res.string.staffing_hint_open_hours: StringResource by lazy {
      StringResource("string:staffing_hint_open_hours", "staffing_hint_open_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 344777, 184),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 491585, 228),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 316516, 160),
      ))
    }

@delegate:ResourceContentHash(-1_945_785_336)
public val Res.string.staffing_hint_too_few: StringResource by lazy {
      StringResource("string:staffing_hint_too_few", "staffing_hint_too_few", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 345099, 129),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 492035, 213),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 316802, 117),
      ))
    }

@delegate:ResourceContentHash(276_395_947)
public val Res.string.staffing_hint_too_few_income: StringResource by lazy {
      StringResource("string:staffing_hint_too_few_income", "staffing_hint_too_few_income", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 344962, 136),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 491814, 220),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 316677, 124),
      ))
    }

@delegate:ResourceContentHash(-1_440_543_139)
public val Res.string.staffing_hint_too_many: StringResource by lazy {
      StringResource("string:staffing_hint_too_many", "staffing_hint_too_many", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 345367, 130),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 492475, 222),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 317050, 118),
      ))
    }

@delegate:ResourceContentHash(1_018_563_539)
public val Res.string.staffing_hint_too_many_income: StringResource by lazy {
      StringResource("string:staffing_hint_too_many_income", "staffing_hint_too_many_income", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 345229, 137),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 492249, 225),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 316920, 129),
      ))
    }

@delegate:ResourceContentHash(-749_736_105)
public val Res.string.staffing_hint_unpriced: StringResource by lazy {
      StringResource("string:staffing_hint_unpriced", "staffing_hint_unpriced", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 345568, 114),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 492788, 190),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 317243, 118),
      ))
    }

@delegate:ResourceContentHash(-1_765_060_175)
public val Res.string.staffing_hint_unpriced_people: StringResource by lazy {
      StringResource("string:staffing_hint_unpriced_people", "staffing_hint_unpriced_people", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 345498, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 492698, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 317169, 73),
      ))
    }

@delegate:ResourceContentHash(-2_123_424_084)
public val Res.string.staffing_just_right_short: StringResource by lazy {
      StringResource("string:staffing_just_right_short", "staffing_just_right_short", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 345683, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 492979, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 317362, 49),
      ))
    }

@delegate:ResourceContentHash(-579_275_363)
public val Res.string.staffing_too_few_short: StringResource by lazy {
      StringResource("string:staffing_too_few_short", "staffing_too_few_short", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 345729, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 493033, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 317412, 42),
      ))
    }

@delegate:ResourceContentHash(241_619_604)
public val Res.string.staffing_too_many_short: StringResource by lazy {
      StringResource("string:staffing_too_many_short", "staffing_too_many_short", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 345772, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 493080, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 317455, 43),
      ))
    }

@delegate:ResourceContentHash(125_045_379)
public val Res.string.start_path_all_set: StringResource by lazy {
      StringResource("string:start_path_all_set", "start_path_all_set", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 345816, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 493136, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 317499, 62),
      ))
    }

@delegate:ResourceContentHash(-1_123_527_604)
public val Res.string.start_path_basics: StringResource by lazy {
      StringResource("string:start_path_basics", "start_path_basics", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 346031, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 493475, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 317730, 49),
      ))
    }

@delegate:ResourceContentHash(-1_517_584_526)
public val Res.string.start_path_basics_action: StringResource by lazy {
      StringResource("string:start_path_basics_action", "start_path_basics_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 345887, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 493235, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 317562, 68),
      ))
    }

@delegate:ResourceContentHash(1_263_385_675)
public val Res.string.start_path_basics_hint: StringResource by lazy {
      StringResource("string:start_path_basics_hint", "start_path_basics_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 345956, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 493344, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 317631, 98),
      ))
    }

@delegate:ResourceContentHash(77_072_268)
public val Res.string.start_path_next: StringResource by lazy {
      StringResource("string:start_path_next", "start_path_next", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 346089, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 493553, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 317780, 39),
      ))
    }

@delegate:ResourceContentHash(362_649_314)
public val Res.string.start_path_publish: StringResource by lazy {
      StringResource("string:start_path_publish", "start_path_publish", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 346291, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 493827, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 317966, 50),
      ))
    }

@delegate:ResourceContentHash(1_178_556_279)
public val Res.string.start_path_publish_action: StringResource by lazy {
      StringResource("string:start_path_publish_action", "start_path_publish_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 346129, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 493597, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 317820, 53),
      ))
    }

@delegate:ResourceContentHash(1_726_954_448)
public val Res.string.start_path_publish_hint: StringResource by lazy {
      StringResource("string:start_path_publish_hint", "start_path_publish_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 346183, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 493671, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 317874, 91),
      ))
    }

@delegate:ResourceContentHash(-1_695_926_954)
public val Res.string.start_path_resume: StringResource by lazy {
      StringResource("string:start_path_resume", "start_path_resume", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 346354, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 493914, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 318017, 33),
      ))
    }

@delegate:ResourceContentHash(114_545_232)
public val Res.string.start_path_roster: StringResource by lazy {
      StringResource("string:start_path_roster", "start_path_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 346948, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 494744, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 318575, 41),
      ))
    }

@delegate:ResourceContentHash(1_267_316_584)
public val Res.string.start_path_roster_action_demand: StringResource by lazy {
      StringResource("string:start_path_roster_action_demand", "start_path_roster_action_demand", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 346400, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 493992, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 318051, 59),
      ))
    }

@delegate:ResourceContentHash(-761_667_245)
public val Res.string.start_path_roster_action_new: StringResource by lazy {
      StringResource("string:start_path_roster_action_new", "start_path_roster_action_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 346472, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 494076, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 318111, 60),
      ))
    }

@delegate:ResourceContentHash(1_556_228_789)
public val Res.string.start_path_roster_hint_assign: StringResource by lazy {
      StringResource("string:start_path_roster_hint_assign", "start_path_roster_hint_assign", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 346529, 213),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 494153, 329),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 318172, 209),
      ))
    }

@delegate:ResourceContentHash(405_254_989)
public val Res.string.start_path_roster_hint_demand: StringResource by lazy {
      StringResource("string:start_path_roster_hint_demand", "start_path_roster_hint_demand", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 346743, 121),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 494483, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 318382, 105),
      ))
    }

@delegate:ResourceContentHash(653_539_648)
public val Res.string.start_path_roster_hint_new: StringResource by lazy {
      StringResource("string:start_path_roster_hint_new", "start_path_roster_hint_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 346865, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 494633, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 318488, 86),
      ))
    }

@delegate:ResourceContentHash(-998_862_046)
public val Res.string.start_path_settled: StringResource by lazy {
      StringResource("string:start_path_settled", "start_path_settled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 346994, 150),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 494806, 218),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 318617, 134),
      ))
    }

@delegate:ResourceContentHash(-152_943_671)
public val Res.string.start_path_share_calendar: StringResource by lazy {
      StringResource("string:start_path_share_calendar", "start_path_share_calendar", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 347145, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 495025, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 318752, 53),
      ))
    }

@delegate:ResourceContentHash(231_833_054)
public val Res.string.start_path_share_hint: StringResource by lazy {
      StringResource("string:start_path_share_hint", "start_path_share_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 347203, 185),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 495119, 313),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 318806, 181),
      ))
    }

@delegate:ResourceContentHash(72_582_899)
public val Res.string.start_path_share_pdf: StringResource by lazy {
      StringResource("string:start_path_share_pdf", "start_path_share_pdf", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 347389, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 495433, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 318988, 60),
      ))
    }

@delegate:ResourceContentHash(824_264_295)
public val Res.string.start_path_skip: StringResource by lazy {
      StringResource("string:start_path_skip", "start_path_skip", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 347489, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 495561, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319088, 31),
      ))
    }

@delegate:ResourceContentHash(823_272_013)
public val Res.string.start_path_skipped: StringResource by lazy {
      StringResource("string:start_path_skipped", "start_path_skipped", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 347446, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 495510, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319049, 38),
      ))
    }

@delegate:ResourceContentHash(-1_394_556_749)
public val Res.string.start_path_team: StringResource by lazy {
      StringResource("string:start_path_team", "start_path_team", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 347812, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 496044, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319403, 35),
      ))
    }

@delegate:ResourceContentHash(980_851_079)
public val Res.string.start_path_team_hint: StringResource by lazy {
      StringResource("string:start_path_team_hint", "start_path_team_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 347521, 128),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 495613, 196),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319120, 112),
      ))
    }

@delegate:ResourceContentHash(-433_329_998)
public val Res.string.start_path_team_import: StringResource by lazy {
      StringResource("string:start_path_team_import", "start_path_team_import", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 347650, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 495810, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319233, 66),
      ))
    }

@delegate:ResourceContentHash(591_044_743)
public val Res.string.start_path_team_invite: StringResource by lazy {
      StringResource("string:start_path_team_invite", "start_path_team_invite", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 347705, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 495897, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319300, 38),
      ))
    }

@delegate:ResourceContentHash(-1_854_440_702)
public val Res.string.start_path_team_without_app: StringResource by lazy {
      StringResource("string:start_path_team_without_app", "start_path_team_without_app", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 347748, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 495952, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319339, 63),
      ))
    }

@delegate:ResourceContentHash(-902_075_048)
public val Res.string.start_path_templates: StringResource by lazy {
      StringResource("string:start_path_templates", "start_path_templates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 348098, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 496406, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319681, 48),
      ))
    }

@delegate:ResourceContentHash(-573_909_974)
public val Res.string.start_path_templates_action: StringResource by lazy {
      StringResource("string:start_path_templates_action", "start_path_templates_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 347848, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 496088, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319439, 63),
      ))
    }

@delegate:ResourceContentHash(-156_843_061)
public val Res.string.start_path_templates_hint: StringResource by lazy {
      StringResource("string:start_path_templates_hint", "start_path_templates_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 347912, 185),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 496172, 233),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319503, 177),
      ))
    }

@delegate:ResourceContentHash(826_869_295)
public val Res.string.start_path_title: StringResource by lazy {
      StringResource("string:start_path_title", "start_path_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 348147, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 496467, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319730, 68),
      ))
    }

@delegate:ResourceContentHash(-202_278_347)
public val Res.string.start_path_week: StringResource by lazy {
      StringResource("string:start_path_week", "start_path_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 348424, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 496868, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319975, 43),
      ))
    }

@delegate:ResourceContentHash(-1_830_830_598)
public val Res.string.start_path_week_action: StringResource by lazy {
      StringResource("string:start_path_week_action", "start_path_week_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 348220, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 496568, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319799, 50),
      ))
    }

@delegate:ResourceContentHash(143_819_785)
public val Res.string.start_path_week_hint: StringResource by lazy {
      StringResource("string:start_path_week_hint", "start_path_week_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 348283, 140),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 496663, 204),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319850, 124),
      ))
    }

@delegate:ResourceContentHash(-1_358_900_055)
public val Res.string.statistics_average_day: StringResource by lazy {
      StringResource("string:statistics_average_day", "statistics_average_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 348472, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 496924, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320019, 50),
      ))
    }

@delegate:ResourceContentHash(-1_586_209_770)
public val Res.string.statistics_base_last_year: StringResource by lazy {
      StringResource("string:statistics_base_last_year", "statistics_base_last_year", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 348527, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 497007, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320070, 69),
      ))
    }

@delegate:ResourceContentHash(1_531_149_980)
public val Res.string.statistics_base_previous: StringResource by lazy {
      StringResource("string:statistics_base_previous", "statistics_base_previous", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 348597, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 497109, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320140, 60),
      ))
    }

@delegate:ResourceContentHash(-392_754_231)
public val Res.string.statistics_best_day: StringResource by lazy {
      StringResource("string:statistics_best_day", "statistics_best_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 348654, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 497194, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320201, 39),
      ))
    }

@delegate:ResourceContentHash(1_539_804_881)
public val Res.string.statistics_by_date: StringResource by lazy {
      StringResource("string:statistics_by_date", "statistics_by_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 348706, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 497258, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320241, 50),
      ))
    }

@delegate:ResourceContentHash(1_688_372_369)
public val Res.string.statistics_by_weekday: StringResource by lazy {
      StringResource("string:statistics_by_weekday", "statistics_by_weekday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 348765, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 497341, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320292, 45),
      ))
    }

@delegate:ResourceContentHash(-16_814_453)
public val Res.string.statistics_chart_description: StringResource by lazy {
      StringResource("string:statistics_chart_description", "statistics_chart_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 348823, 132),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 497407, 196),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320338, 120),
      ))
    }

@delegate:ResourceContentHash(1_896_432_615)
public val Res.string.statistics_chart_title: StringResource by lazy {
      StringResource("string:statistics_chart_title", "statistics_chart_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 348956, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 497604, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320459, 50),
      ))
    }

@delegate:ResourceContentHash(1_057_620_648)
public val Res.string.statistics_compare_with: StringResource by lazy {
      StringResource("string:statistics_compare_with", "statistics_compare_with", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 349015, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 497671, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320510, 47),
      ))
    }

@delegate:ResourceContentHash(-2_115_040_270)
public val Res.string.statistics_day_against: StringResource by lazy {
      StringResource("string:statistics_day_against", "statistics_day_against", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 349063, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 497731, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320558, 54),
      ))
    }

@delegate:ResourceContentHash(1_905_662_477)
public val Res.string.statistics_days_with_takings: StringResource by lazy {
      StringResource("string:statistics_days_with_takings", "statistics_days_with_takings", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 349118, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 497786, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320613, 80),
      ))
    }

@delegate:ResourceContentHash(1_066_914_027)
public val Res.string.statistics_markers_note: StringResource by lazy {
      StringResource("string:statistics_markers_note", "statistics_markers_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 349191, 151),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 497883, 207),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320694, 147),
      ))
    }

@delegate:ResourceContentHash(-1_971_189_368)
public val Res.string.statistics_metric: StringResource by lazy {
      StringResource("string:statistics_metric", "statistics_metric", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 349397, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 498169, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320896, 33),
      ))
    }

@delegate:ResourceContentHash(-1_927_464_469)
public val Res.string.statistics_metric_labour_cost: StringResource by lazy {
      StringResource("string:statistics_metric_labour_cost", "statistics_metric_labour_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 349343, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 498091, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320842, 53),
      ))
    }

@delegate:ResourceContentHash(1_312_007_426)
public val Res.string.statistics_move_back: StringResource by lazy {
      StringResource("string:statistics_move_back", "statistics_move_back", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 349435, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 498219, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320930, 60),
      ))
    }

@delegate:ResourceContentHash(-1_593_583_413)
public val Res.string.statistics_move_forward: StringResource by lazy {
      StringResource("string:statistics_move_forward", "statistics_move_forward", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 349500, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 498316, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320991, 59),
      ))
    }

@delegate:ResourceContentHash(-445_197_949)
public val Res.string.statistics_no_access: StringResource by lazy {
      StringResource("string:statistics_no_access", "statistics_no_access", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 349568, 128),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 498412, 192),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321051, 124),
      ))
    }

@delegate:ResourceContentHash(-393_566_812)
public val Res.string.statistics_no_counterpart: StringResource by lazy {
      StringResource("string:statistics_no_counterpart", "statistics_no_counterpart", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 349697, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 498605, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321176, 53),
      ))
    }

@delegate:ResourceContentHash(1_069_352_123)
public val Res.string.statistics_no_previous: StringResource by lazy {
      StringResource("string:statistics_no_previous", "statistics_no_previous", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 349767, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 498695, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321230, 74),
      ))
    }

@delegate:ResourceContentHash(1_140_433_160)
public val Res.string.statistics_no_takings: StringResource by lazy {
      StringResource("string:statistics_no_takings", "statistics_no_takings", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 349842, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 498806, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321305, 81),
      ))
    }

@delegate:ResourceContentHash(1_718_954_692)
public val Res.string.statistics_period: StringResource by lazy {
      StringResource("string:statistics_period", "statistics_period", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 350064, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 499088, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321515, 33),
      ))
    }

@delegate:ResourceContentHash(-1_073_051_978)
public val Res.string.statistics_period_custom: StringResource by lazy {
      StringResource("string:statistics_period_custom", "statistics_period_custom", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 349928, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 498924, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321387, 48),
      ))
    }

@delegate:ResourceContentHash(-809_964_435)
public val Res.string.statistics_period_month: StringResource by lazy {
      StringResource("string:statistics_period_month", "statistics_period_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 349977, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 498989, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321436, 39),
      ))
    }

@delegate:ResourceContentHash(-1_778_836_424)
public val Res.string.statistics_period_week: StringResource by lazy {
      StringResource("string:statistics_period_week", "statistics_period_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 350021, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 499037, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321476, 38),
      ))
    }

@delegate:ResourceContentHash(397_328_080)
public val Res.string.statistics_pick_range: StringResource by lazy {
      StringResource("string:statistics_pick_range", "statistics_pick_range", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 350098, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 499130, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321549, 57),
      ))
    }

@delegate:ResourceContentHash(-373_705_876)
public val Res.string.statistics_previous_month: StringResource by lazy {
      StringResource("string:statistics_previous_month", "statistics_previous_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 350152, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 499212, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321607, 53),
      ))
    }

@delegate:ResourceContentHash(2_030_318_557)
public val Res.string.statistics_previous_period: StringResource by lazy {
      StringResource("string:statistics_previous_period", "statistics_previous_period", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 350210, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 499290, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321661, 54),
      ))
    }

@delegate:ResourceContentHash(-196_349_810)
public val Res.string.statistics_summary_title: StringResource by lazy {
      StringResource("string:statistics_summary_title", "statistics_summary_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 350265, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 499369, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321716, 44),
      ))
    }

@delegate:ResourceContentHash(-1_823_648_384)
public val Res.string.statistics_title: StringResource by lazy {
      StringResource("string:statistics_title", "statistics_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 350314, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 499426, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321761, 40),
      ))
    }

@delegate:ResourceContentHash(-1_641_193_974)
public val Res.string.statistics_total: StringResource by lazy {
      StringResource("string:statistics_total", "statistics_total", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 350406, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 499546, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321861, 32),
      ))
    }

@delegate:ResourceContentHash(980_806_906)
public val Res.string.statistics_total_share: StringResource by lazy {
      StringResource("string:statistics_total_share", "statistics_total_share", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 350355, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 499479, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321802, 58),
      ))
    }

@delegate:ResourceContentHash(-1_229_960_623)
public val Res.string.statistics_weekday_header: StringResource by lazy {
      StringResource("string:statistics_weekday_header", "statistics_weekday_header", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 350439, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 499587, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321894, 45),
      ))
    }

@delegate:ResourceContentHash(-1_224_542_718)
public val Res.string.statistics_weekdays_title: StringResource by lazy {
      StringResource("string:statistics_weekdays_title", "statistics_weekdays_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 350493, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 499649, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321940, 65),
      ))
    }

@delegate:ResourceContentHash(-517_710_077)
public val Res.string.statistics_weeks_description: StringResource by lazy {
      StringResource("string:statistics_weeks_description", "statistics_weeks_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 350575, 156),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 499759, 220),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 322006, 144),
      ))
    }

@delegate:ResourceContentHash(865_677_672)
public val Res.string.statistics_worst_day: StringResource by lazy {
      StringResource("string:statistics_worst_day", "statistics_worst_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 350732, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 499980, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 322151, 44),
      ))
    }

@delegate:ResourceContentHash(324_645_577)
public val Res.string.status_value: StringResource by lazy {
      StringResource("string:status_value", "status_value", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 350785, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 500049, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 322196, 36),
      ))
    }

@delegate:ResourceContentHash(1_339_965_548)
public val Res.string.subscription_billing_issue: StringResource by lazy {
      StringResource("string:subscription_billing_issue", "subscription_billing_issue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 350822, 178),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 500094, 270),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 322233, 150),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString41Resources(map: MutableMap<String, StringResource>) {
  map.put("staff_status_expired", Res.string.staff_status_expired)
  map.put("staff_status_expiring", Res.string.staff_status_expiring)
  map.put("staff_status_missing", Res.string.staff_status_missing)
  map.put("staff_status_valid", Res.string.staff_status_valid)
  map.put("staffing_card_all_right", Res.string.staffing_card_all_right)
  map.put("staffing_card_open", Res.string.staffing_card_open)
  map.put("staffing_card_summary", Res.string.staffing_card_summary)
  map.put("staffing_card_summary_both", Res.string.staffing_card_summary_both)
  map.put("staffing_card_title", Res.string.staffing_card_title)
  map.put("staffing_hint_add_hours", Res.string.staffing_hint_add_hours)
  map.put("staffing_hint_cut_hours", Res.string.staffing_hint_cut_hours)
  map.put("staffing_hint_from_forecast", Res.string.staffing_hint_from_forecast)
  map.put("staffing_hint_from_recent", Res.string.staffing_hint_from_recent)
  map.put("staffing_hint_from_target", Res.string.staffing_hint_from_target)
  map.put("staffing_hint_income", Res.string.staffing_hint_income)
  map.put("staffing_hint_income_fixed", Res.string.staffing_hint_income_fixed)
  map.put("staffing_hint_income_sales_fixed", Res.string.staffing_hint_income_sales_fixed)
  map.put("staffing_hint_just_right", Res.string.staffing_hint_just_right)
  map.put("staffing_hint_just_right_income", Res.string.staffing_hint_just_right_income)
  map.put("staffing_hint_open_estimated", Res.string.staffing_hint_open_estimated)
  map.put("staffing_hint_open_hours", Res.string.staffing_hint_open_hours)
  map.put("staffing_hint_too_few", Res.string.staffing_hint_too_few)
  map.put("staffing_hint_too_few_income", Res.string.staffing_hint_too_few_income)
  map.put("staffing_hint_too_many", Res.string.staffing_hint_too_many)
  map.put("staffing_hint_too_many_income", Res.string.staffing_hint_too_many_income)
  map.put("staffing_hint_unpriced", Res.string.staffing_hint_unpriced)
  map.put("staffing_hint_unpriced_people", Res.string.staffing_hint_unpriced_people)
  map.put("staffing_just_right_short", Res.string.staffing_just_right_short)
  map.put("staffing_too_few_short", Res.string.staffing_too_few_short)
  map.put("staffing_too_many_short", Res.string.staffing_too_many_short)
  map.put("start_path_all_set", Res.string.start_path_all_set)
  map.put("start_path_basics", Res.string.start_path_basics)
  map.put("start_path_basics_action", Res.string.start_path_basics_action)
  map.put("start_path_basics_hint", Res.string.start_path_basics_hint)
  map.put("start_path_next", Res.string.start_path_next)
  map.put("start_path_publish", Res.string.start_path_publish)
  map.put("start_path_publish_action", Res.string.start_path_publish_action)
  map.put("start_path_publish_hint", Res.string.start_path_publish_hint)
  map.put("start_path_resume", Res.string.start_path_resume)
  map.put("start_path_roster", Res.string.start_path_roster)
  map.put("start_path_roster_action_demand", Res.string.start_path_roster_action_demand)
  map.put("start_path_roster_action_new", Res.string.start_path_roster_action_new)
  map.put("start_path_roster_hint_assign", Res.string.start_path_roster_hint_assign)
  map.put("start_path_roster_hint_demand", Res.string.start_path_roster_hint_demand)
  map.put("start_path_roster_hint_new", Res.string.start_path_roster_hint_new)
  map.put("start_path_settled", Res.string.start_path_settled)
  map.put("start_path_share_calendar", Res.string.start_path_share_calendar)
  map.put("start_path_share_hint", Res.string.start_path_share_hint)
  map.put("start_path_share_pdf", Res.string.start_path_share_pdf)
  map.put("start_path_skip", Res.string.start_path_skip)
  map.put("start_path_skipped", Res.string.start_path_skipped)
  map.put("start_path_team", Res.string.start_path_team)
  map.put("start_path_team_hint", Res.string.start_path_team_hint)
  map.put("start_path_team_import", Res.string.start_path_team_import)
  map.put("start_path_team_invite", Res.string.start_path_team_invite)
  map.put("start_path_team_without_app", Res.string.start_path_team_without_app)
  map.put("start_path_templates", Res.string.start_path_templates)
  map.put("start_path_templates_action", Res.string.start_path_templates_action)
  map.put("start_path_templates_hint", Res.string.start_path_templates_hint)
  map.put("start_path_title", Res.string.start_path_title)
  map.put("start_path_week", Res.string.start_path_week)
  map.put("start_path_week_action", Res.string.start_path_week_action)
  map.put("start_path_week_hint", Res.string.start_path_week_hint)
  map.put("statistics_average_day", Res.string.statistics_average_day)
  map.put("statistics_base_last_year", Res.string.statistics_base_last_year)
  map.put("statistics_base_previous", Res.string.statistics_base_previous)
  map.put("statistics_best_day", Res.string.statistics_best_day)
  map.put("statistics_by_date", Res.string.statistics_by_date)
  map.put("statistics_by_weekday", Res.string.statistics_by_weekday)
  map.put("statistics_chart_description", Res.string.statistics_chart_description)
  map.put("statistics_chart_title", Res.string.statistics_chart_title)
  map.put("statistics_compare_with", Res.string.statistics_compare_with)
  map.put("statistics_day_against", Res.string.statistics_day_against)
  map.put("statistics_days_with_takings", Res.string.statistics_days_with_takings)
  map.put("statistics_markers_note", Res.string.statistics_markers_note)
  map.put("statistics_metric", Res.string.statistics_metric)
  map.put("statistics_metric_labour_cost", Res.string.statistics_metric_labour_cost)
  map.put("statistics_move_back", Res.string.statistics_move_back)
  map.put("statistics_move_forward", Res.string.statistics_move_forward)
  map.put("statistics_no_access", Res.string.statistics_no_access)
  map.put("statistics_no_counterpart", Res.string.statistics_no_counterpart)
  map.put("statistics_no_previous", Res.string.statistics_no_previous)
  map.put("statistics_no_takings", Res.string.statistics_no_takings)
  map.put("statistics_period", Res.string.statistics_period)
  map.put("statistics_period_custom", Res.string.statistics_period_custom)
  map.put("statistics_period_month", Res.string.statistics_period_month)
  map.put("statistics_period_week", Res.string.statistics_period_week)
  map.put("statistics_pick_range", Res.string.statistics_pick_range)
  map.put("statistics_previous_month", Res.string.statistics_previous_month)
  map.put("statistics_previous_period", Res.string.statistics_previous_period)
  map.put("statistics_summary_title", Res.string.statistics_summary_title)
  map.put("statistics_title", Res.string.statistics_title)
  map.put("statistics_total", Res.string.statistics_total)
  map.put("statistics_total_share", Res.string.statistics_total_share)
  map.put("statistics_weekday_header", Res.string.statistics_weekday_header)
  map.put("statistics_weekdays_title", Res.string.statistics_weekdays_title)
  map.put("statistics_weeks_description", Res.string.statistics_weeks_description)
  map.put("statistics_worst_day", Res.string.statistics_worst_day)
  map.put("status_value", Res.string.status_value)
  map.put("subscription_billing_issue", Res.string.subscription_billing_issue)
}
